import React, { useState } from "react";
import styles from "./Button.module.css";
import KeyImage from "../../images/keyboardkey.png";

function Button({ imageButtonFull, imageButtonPressed, keyName, isPressed }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.keyWrapper}>
        <span className={styles.keyName}>{keyName}</span>
        <img src={KeyImage} alt="keyboard key" />
      </div>
      {!isPressed ? (
        <img src={imageButtonFull} alt="image button" />
      ) : (
        <img src={imageButtonPressed} alt="image button pressed" />
      )}
    </div>
  );
}

export default Button;
